module.exports = __webpack_public_path__ + "img/eSIM-Dark.6df1ff7.svg";